<template>
  <Menu v-if="locales" v-slot="{ close }" class="relative" as="div">
    <MenuButton
      v-if="brandconfig.lang?.length && brandconfig.lang.length > 1"
      class="flex gap-1 items-center"
      style="width: max-content">
      <img
        v-if="code.length === 3"
        class="w-5 aspect-square object-cover rounded-full border-2 border-white"
        :alt="country ? `${$t('Change language to')} ${country}` : `Change language to ${code}`"
        :src="getFlagUrl(code)" />

      <span class="text-sm">{{ langCode }}</span>

      <ChevronDownIcon class="size-3 flex-none" />
    </MenuButton>

    <MenuItems
      class="fixed w-full h-auto mt-5 lg:w-auto lg:h-auto lg:absolute flex-col right-0 z-20 lg:mt-2 lg:pb-1 origin-top-right lg:rounded-md bg-surface text-foreground lg:shadow-lg lg:ring-1 lg:ring-black/5 overflow-hidden focus:outline-none">
      <div class="flex justify-between">
        <h3 class="text-lg font-bold px-4 pb-2 pt-4">{{ $t("Language") }}</h3>
        <button class="lg:hidden mr-5" @click="close">
          <XMarkIcon class="h-5" />
        </button>
      </div>
      <div class="py-0.5">
        <MenuItem v-for="locale of locales" :key="locale" v-slot="{ active }">
          <button class="w-full" :class="{ 'bg-gray-100 ': active }" @click="switchLocale(locale)">
            <div class="px-4 py-2 text-left flex min-w-max justify-between gap-2 items-center">
              <CountryFlag small :code="LOCALES[locale]?.flag" :country="LOCALES[locale]?.title" />
              <span class="grow">{{ LOCALES[locale]?.title }}</span>
              <CheckIcon v-if="$i18n.locale === locale" class="w-5" />
            </div>
          </button>
        </MenuItem>
      </div>
    </MenuItems>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { CheckIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { useDistributorStore } from "@/store/distributor.js";
import brandconfig from "@/brandconfig";
import CountryFlag from "@/components/CountryFlag.vue";
import { getFlagUrl, setLocale } from "@xs2event/js-lib/util";
import { LOCALES, locales } from "./locales.js";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";
import { computed } from "vue";

import { useUserStore } from "@/store/user.js";
import { isB2C } from "@/brandconfig";
import { i18n } from "../../../i18n.ts";
import { useEventStore } from "@/store/event.js";
import { useCartStore } from "@/store/cart.ts";
import { useI18n } from "vue-i18n";

const cartStore = useCartStore();
const eventStore = useEventStore();
const userStore = useUserStore();

const { locale } = useI18n();

const distributorStore = useDistributorStore();

const country = computed(() => LOCALES[locale.value]?.title);

const switchLocale = (option) => {
  if (isB2C) {
    setLocale((i18n.locale = option));
  } else {
    if (userStore.client_id) {
      if (!!cartStore.items.length > 0) {
        updateCartLocale(option);
        distributorStore.languageChanged++;
      } else {
        userStore.updateLocale(option);
        setLocale(option);
        distributorStore.languageChanged++;
      }
    } else {
      setLocale(option);
      distributorStore.languageChanged++;
    }
  }
};

const code = computed(() => {
  return LOCALES[locale.value]?.flag;
});

const langCode = computed(() => {
  return LOCALES[locale.value]?.title;
});

const updateCartLocale = (option) => {
  let cartItems = [];
  userStore.updateLocale(option).then(() => {
    cartItems = JSON.parse(localStorage[userStore.client_id]).items;
    cartItems.forEach((item) => {
      eventStore
        .fetchPreferredLanguageEvent(item.event.event_id, option)
        .then((res) => {
          item.event.event_name = res.event_name;
        })
        .then(() => {
          delete localStorage[userStore.client_id];
          localStorage[userStore.client_id] = JSON.stringify(cartItems);
          cartStore.items = cartItems;
          cartStore.updateReservation();
          setLocale(option);
        });
    });
  });
};
</script>
